import { Model } from '@vuex-orm/core'

export default class Candidate extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'candidates'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      photo_media_id: this.attr(null),
      photo_media_url: this.attr(null),
      name: this.attr(null),
      email: this.attr(null),
      disability: this.attr(null),
      disability_comment: this.attr(null),
      birth_date: this.attr(null),
      gender: this.attr(null),
      phones: this.attr(null),
      country: this.attr(null),
      region: this.attr(null),
      city: this.attr(null),
      neighborhood: this.attr(null),
      address: this.attr(null),
      zipcode: this.attr(null),
      loc: this.attr(null),
      position_category: this.attr(null),
      experience_level: this.attr(null),
      headline: this.attr(null),
      salary: this.attr(null),
      summary: this.attr(null),
      informations: this.attr(null),
      keywords: this.attr(null),
      origin: this.attr(null),
      source_id: this.attr(null),
      resume_media_id: this.attr(null),
      resume_media_url: this.attr(null),
      resume_content: this.attr(null),
      skills: this.attr(null),
      experiences: this.attr(null),
      educations: this.attr(null),
      tags: this.attr(null),
      languages: this.attr(null),
      pages: this.attr(null),
      custom_fields: this.attr(null),
      avg_rating: this.attr(null),
      author_user_id: this.attr(null),
      account_id: this.attr(null),
      publicate_display: this.attr(null),
      placements: this.attr(null),
      next_event: this.attr(null),
      followers: this.attr(null),
      diversity_status: this.attr(null),
      gdpr: this.attr(null),
      highlight: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Candidate.js